import type { FC, ReactNode } from 'react';

import { cn } from '@/utils/cn.util';

type Tone = 'brand' | 'success' | 'info' | 'warn' | 'danger' | 'pink' | 'neutral';

interface PillProps {
  tone: Tone;
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}

const toneStyles: Record<Tone, string> = {
  brand: 'bg-brand-50 text-brand-600',
  success: 'bg-[var(--color-success-bg)] text-[var(--color-success-ink)]',
  info: 'bg-[var(--color-info-bg)] text-[var(--color-info-ink)]',
  warn: 'bg-[var(--color-warn-bg)] text-[var(--color-warn-ink)]',
  danger: 'bg-[var(--color-danger-bg)] text-[var(--color-danger-ink)]',
  pink: 'bg-[var(--color-pink-bg)] text-[var(--color-pink-ink)]',
  neutral: 'bg-[var(--color-surface-muted-2)] text-[var(--color-ink-muted)]',
};

const Pill: FC<PillProps> = ({ tone, icon, children, className }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold leading-none',
      toneStyles[tone],
      className,
    )}
  >
    {icon}
    {children}
  </span>
);

export default Pill;
